<template>
  <div v-for="(value, attribute) in properties.attributes" :key="attribute">
    <div class="row">
      <div class="col-3 text-truncate">{{ trans(`models.${resourceType}.attributes.${attribute}`) }}:</div>
      <div class="col-4">
        <presentation-field
          :meta="meta"
          :column="attribute"
          :column-type="getColumnType(attribute)"
          :mutation="meta.mutations[attribute] ?? null"
          :resource-type="resourceType"
          :value="getValue(attribute, 'old')"
        ></presentation-field>
      </div>
      <div class="col-1">
        <i class="bi bi-caret-right-fill text-primary"></i>
      </div>
      <div class="col-4">
        <presentation-field
          :meta="meta"
          :column="attribute"
          :column-type="getColumnType(attribute)"
          :mutation="meta.mutations[attribute] ?? null"
          :resource-type="resourceType"
          :value="getValue(attribute, 'attributes')"
        ></presentation-field>
      </div>
    </div>
  </div>
</template>

<script>
import PresentationField from '@kanrisha/components/Presentation/PresentationField';

export default {
  components: {
    PresentationField,
  },
  props: {
    properties: { type: Object, default: () => {} },
    relations: { type: Object, default: () => {} },
    resourceType: { type: String, default: () => '' },
    meta: { type: Object, default: () => {} },
  },
  setup(props) {
    const getValue = (column, category) => {
      if (getColumnType(column) === 'relation' && props.relations) {
        let relation = column.substring(0, column.length - 3);
        return props.relations[category] ? props.relations[category][relation] : null;
      }

      return props.properties[category] ? props.properties[category][column] : null;
    };

    const getColumnType = (column) => {
      return props.meta.elementTypes[column.substring(0, column.length - 3)] ?? props.meta.elementTypes[column];
    };

    return {
      getColumnType,
      getValue,
    };
  },
};
</script>
